export const PaymentSteps = {
  ConnectPayment: "ConnectPayment",
  AddPayment: "AddPayment",
};
